import { ChevronLeft, ChevronRight, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { resolveImageUrl } from "@/lib/api";

export function ListingGallery({ images, title, active, setActive, lightboxOpen, setLightboxOpen }) {
  return (
    <>
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="gallery">
        <div className="relative aspect-[16/10] bg-slate-100">
          <img src={resolveImageUrl(images[active])} alt={title} onClick={() => setLightboxOpen(true)} data-testid="gallery-main-image" className="w-full h-full object-cover cursor-zoom-in" />
          <button onClick={() => setLightboxOpen(true)} data-testid="open-lightbox" aria-label="View full screen" className="absolute right-2 bottom-2 bg-white/90 rounded-full p-2 shadow text-slate-700"><Maximize2 size={16} /></button>
          {images.length > 1 && (
            <>
              <button onClick={() => setActive((a) => (a - 1 + images.length) % images.length)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 shadow"><ChevronLeft size={18} /></button>
              <button onClick={() => setActive((a) => (a + 1) % images.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 shadow"><ChevronRight size={18} /></button>
            </>
          )}
        </div>
        {images.length > 1 && (
          <div className="flex gap-2 p-3 overflow-x-auto no-scrollbar">
            {images.map((img, i) => (
              <img key={img} src={resolveImageUrl(img)} onClick={() => setActive(i)} alt={`${title} - photo ${i + 1} of ${images.length}`} className={`w-20 h-16 object-cover rounded cursor-pointer border-2 ${i === active ? "border-emerald-600" : "border-transparent"}`} />
            ))}
          </div>
        )}
      </div>

      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent data-testid="lightbox" className="max-w-4xl p-0 bg-black border-0 overflow-hidden">
          <DialogHeader className="sr-only">
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>Photo {active + 1} of {images.length}</DialogDescription>
          </DialogHeader>
          <div className="relative flex items-center justify-center">
            <img src={resolveImageUrl(images[active])} alt={title} className="w-full max-h-[80vh] object-contain" data-testid="lightbox-image" />
            {images.length > 1 && (
              <>
                <button onClick={() => setActive((active - 1 + images.length) % images.length)} data-testid="lightbox-prev" aria-label="Previous photo" className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 text-slate-800"><ChevronLeft size={20} /></button>
                <button onClick={() => setActive((active + 1) % images.length)} data-testid="lightbox-next" aria-label="Next photo" className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 text-slate-800"><ChevronRight size={20} /></button>
                <span className="absolute bottom-2 left-1/2 -translate-x-1/2 text-xs text-white/80 bg-black/40 px-2 py-0.5 rounded-full">{active + 1} / {images.length}</span>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
